import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

import NotificationSettingsTableRow from './NotificationSettingsTableRow';
import {Permission} from "../../../../../../components/SessionInfo";

const sticky = {
  position: 'sticky',
  top: 0,
  backgroundColor: '#fff'
};

function NotificationSettingsTable({ rows, triggerRefetch, permission }) {
  return (
    <TableContainer component={Paper} sx={{width: 'auto', boxShadow: 'none', height: '100%'}}>
      <Table sx={{minWidth: 650}}>
        <TableHead>
          <TableRow>
            <TableCell sx={sticky}>Номер настройки уведомлений</TableCell>
            <TableCell sx={sticky}>За какое количество единиц времени уведомлять</TableCell>
            <TableCell sx={sticky}>Единица времени</TableCell>
            { permission === Permission.WRITE ? <TableCell sx={sticky}></TableCell> : null }
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row, i) => (
            <NotificationSettingsTableRow permission={permission} row={{...row, number: i + 1}} triggerRefetch={triggerRefetch} key={row.id} />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default NotificationSettingsTable;
